import { PUBLIC_API_KEY } from '@config/game.js'
import { queryString } from '@helpers/utils.js'
import { PUBLIC_BASE_URL } from '@config'
import { createClient } from '@services'
import qs from 'qs'

const { post } = createClient()

export async function submitReportRequest(report) {
  const query = { api_key: PUBLIC_API_KEY }
  const { data } = await post(
    `${PUBLIC_BASE_URL}/report${queryString(query)}`,
    qs.stringify(report),
  )
  return data
}
